import store from "@/store/index"
import networkConnectivityConfig from "@/configs/networkConnectivityConfig.js"
import { refreshNetworkSlowConnectionState } from "@/helpers/networkSlowConnection.js"

let isAttached = false

/**
 * Browser online/offline listeners for dashboard network messaging.
 * Kept separate from websocket.js so banner state does not depend on Reverb reconnect.
 */
export const initNetworkConnectivityListeners = () => {
  if (!networkConnectivityConfig.speedStatusEnabled) {
    return
  }
  if (isAttached || typeof window === "undefined") {
    return
  }
  isAttached = true

  const syncFromNavigator = () => {
    store.dispatch("networkConnectivity/syncBrowserOnlineFromNavigator")
  }

  const onBrowserOnline = () => {
    syncFromNavigator()
    refreshNetworkSlowConnectionState()
  }

  window.addEventListener("offline", () => {
    store.dispatch("networkConnectivity/setBrowserOnline", false)
  })
  window.addEventListener("online", onBrowserOnline)
  window.addEventListener("focus", () => {
    syncFromNavigator()
    refreshNetworkSlowConnectionState()
  })
  if (typeof document !== "undefined") {
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        syncFromNavigator()
        refreshNetworkSlowConnectionState()
      }
    })
  }

  syncFromNavigator()
}
